const modal = {
    namespaced: true,

    state: {
        invoices: [],
    },

    mutations: {
        TOGGLE_PAYMENT_TABS(state, payload) {
            state.invoices = payload;
        },
        FETCH_INVOICES(state, payload) {
            state.invoices = payload;
        },
    },

    actions: {
        // toggle active tab
        handlePaymentTabs({ commit, state }, payload) {
            const tabs = state.invoices.map((tab) => {
                if (tab.id === payload) {
                    return {
                        ...tab,
                        isActive: true,
                    };
                } else {
                    return {
                        ...tab,
                        isActive: false,
                    };
                }
            });
            commit("TOGGLE_PAYMENT_TABS", tabs);
        },
        // fetch invoices
        fetchInvoices({ commit }, payload) {
            let invoices;
            if (payload.invoices && payload.invoices.length) {
                // clean up invoices
                invoices = payload.invoices.map((invoice) => {
                    const payments = invoice.payments.map((payment) => {
                        const cost = parseFloat(payment.cost);
                        return {
                            ...payment,
                            status: `${
                                payment.status_pretty === "Failed Temp"
                                    ? "Failed"
                                    : payment.status_pretty
                            }`,
                            cost,
                            name: `${payment.user.first_name} ${payment.user.last_name}`,
                            user_email: payment.user.email,
                            user_phone_number: payment.user.phone_number,
                        };
                    });

                    payments.sort(function (a, b) {
                        return b.attempt - a.attempt;
                    });
                    return {
                        ...invoice,
                        isActive: false,
                        payments,
                    };
                });
                invoices.sort(function (a, b) {
                    return new Date(b.created_at) - new Date(a.created_at);
                });
                invoices[0].isActive = true;

                const output = invoices.map((invoice) => {
                    const start = new Date(invoice.created_at);
                    const end = new Date(start.setMonth(start.getMonth() + 1));
                    end.setHours(0, 0, 0, 0);

                    const invoicePayouts = payload.payouts[invoice.id];

                    // Return invoice if no payouts
                    if (invoicePayouts === undefined) {
                        return {
                            ...invoice,
                            start: new Date(invoice.created_at),
                            end,
                        };
                    }

                    let outbound = Object.entries(invoicePayouts.payouts)
                        .filter(
                            // only display bill names (This removes uplifts)
                            ([key, payout]) => [0, 1, 5].includes(payout.type_id)
                        )
                        .map(([key, payout]) => {
                            const supplier = payout.provider?.name;
                            const paid = !!payout.paid_at;
                            const uplifts = Object.values(invoicePayouts.payouts)
                                .filter(
                                    (linkedPayout) => linkedPayout.bill_id === payout.bill_id &&
                                        ! [0, 1, 5].includes(linkedPayout.type_id)
                                )

                            const upliftTotal = uplifts.reduce((total, uplift) => total + parseFloat(uplift.amount), 0);
                            const amount = parseFloat(payout.amount) + upliftTotal;

                            return {
                                supplier,
                                paid,
                                ...payout,
                                amount,
                            };
                        });

                    // Merge Homebox Service Fee into invoice payouts
                    outbound = [
                        ...outbound,
                        {
                            supplier: "Homebox Service",
                            payment_reference: "-",
                            paid: invoicePayouts.total_service_fee_status === "success",
                            paid_at: null,
                            amount: invoicePayouts.total_service_fee,
                        },
                    ];
                    return {
                        ...invoice,
                        outbound,
                        start: new Date(invoice.created_at),
                        end,
                    };
                });

                // Sort order of payouts listing
                const sorted = output.map((invoice) => {
                    if (!invoice?.outbound) {
                        return invoice;
                    }

                    const sortedPayouts = invoice.outbound.sort(function (
                        a,
                        b
                    ) {
                        if (a.supplier < b.supplier) {
                            return -1;
                        }
                        if (a.supplier > b.supplier) {
                            return 1;
                        }
                        return 0;
                    });
                    return {
                        ...invoice,
                        sortedPayouts,
                    };
                });
                commit("FETCH_INVOICES", sorted);
            } else {
                commit("FETCH_INVOICES", []);
            }
        },
    },
};

export default modal;
